// extracted by mini-css-extract-plugin
export default {"link":"Menu_link__jri6+","main":"Menu_main__nyeRl"};